import { createContext, useContext } from 'react';

// The signed-in staff member (issue #251), provided by AuthGate.js.
// currentUser is null while the tenant is still on the shared app password
// (no staff member has set their own password yet).
export const StaffAuthContext = createContext(null);

export function useStaffAuth() {
  const ctx = useContext(StaffAuthContext);
  if (!ctx) {
    throw new Error('useStaffAuth() must be used within AuthGate');
  }
  return ctx;
}
